import { Box, Typography, LinearProgress } from "@mui/material";

export default function UsageProgress({ label, used, limit }) {
  const isUnlimited = limit === -1;

  const percentage = isUnlimited ? 0 : Math.min((used / limit) * 100, 100);

  const getColor = () => {
    if (isUnlimited) return "primary";

    if (percentage < 50) return "success";
    if (percentage < 80) return "warning";
    return "error";
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>

        <Typography variant="body2" fontWeight={600}>
          {used}/{isUnlimited ? "∞" : limit}
        </Typography>
      </Box>

      <LinearProgress
        variant={isUnlimited ? "indeterminate" : "determinate"}
        value={isUnlimited ? undefined : percentage}
        color={getColor()}
        sx={{
          mt: 1,
          height: 8,
          borderRadius: 5,
          bgcolor: "#E0E0E0" // base background
        }}
      />
    </Box>
  );
}
